<div class="step-wrapper" [formGroup]="getStepBeginFormGroup()">
    <h3 class="section-title"
        i18n="XGRP|Title of existing resources section@@organizations.unified-step-begin.existingResourcesCheck">
        Existing Resources Check</h3>
    <app-container [body]="beginContainer" class="margin-bottom"></app-container>
    <ng-template #beginContainer>
        <div class="begin-container">
            <p><b>Does your application already have resources in the unified services framework?</b></p>
            <p>This wizard registers your application’s Tenant type using a ManagedService and ResourceTypeDefinition
                (RTD), along with additional resources. If these already exist for your application, <b>do not use this
                    wizard</b>. Doing so will create an unsupported configuration, duplicates, and unnecessary support tickets.
            </p>

            <div class="hint-section">
                <div>
                    <fa-icon icon="info-circle" size="lg"></fa-icon>
                </div>

                <div>
                    <b>Not sure? </b> <a
                        fd-link
                        href="https://jira.tools.sap/browse/SAPBTPCFSSR-1?jql=project%20%3D%20SAPBTPCFSSR%20AND%20summary%20~%20%22Request%20for%20Provider%20Folder%22"
                        target="_blank">Search Jira</a> for an existing provider folder. If one exists, your application
                    is
                    likely already
                    onboarded. You can reach out to the contacts listed there for more information and request access.
                </div>
            </div>

            <div>
                <b>Proceed with this wizard only if either of these conditions apply</b>:

                <ul>
                    <li>Your application has no existing ManagedService and RTD.</li>
                    <li>You’re setting up a non-productive scenario (such as a proof-of-concept or demo).
                    </li>
                </ul>

            </div>

            <div>
                <fd-checkbox formControlName="acknowledged" name="acknowledged">
                    My application does not already have a ManagedService and RTD, or I am running a non-productive
                    scenario.
                </fd-checkbox>
            </div>
        </div>
    </ng-template>


</div>

